import { createContext } from "react";

export const LocaleContext = createContext<Intl.Locale>(
  undefined as unknown as Intl.Locale
);
